import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Profile } from 'src/app/models/Profile';

@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    private profileUrl = environment.profileUrl;

    constructor(private http: HttpClient, private authService: AuthService) { }

    private getHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.authService.getToken()
        });
    }

    public getAllProfiles(): Observable<Profile[]> {
        return this.http.get<Profile[]>(this.profileUrl + '/all', { headers: this.getHeaders() });
    }

    public getProfileById(id: string): Observable<Profile> {
        return this.http.get<Profile>(this.profileUrl + '/' + id, { headers: this.getHeaders() });
    }

    public addProfile(profile: Profile): Observable<Profile> {
        return this.http.post<Profile>(this.profileUrl, profile, { headers: this.getHeaders() });
    }

    public updateProfile(id: string, profile: Profile): Observable<Profile> {
        return this.http.put<Profile>(this.profileUrl + '/' + id, profile, { headers: this.getHeaders() });
    }

    public deleteProfile(id: string): Observable<any> {
        return this.http.delete<any>(this.profileUrl + '/' + id, { headers: this.getHeaders() });
    }

    public getProfileUsageCounts(): Observable<{ [profileId: string]: number }> {
        return this.http.get<{ [profileId: string]: number }>(this.profileUrl + '/usage-counts', { headers: this.getHeaders() });
    }

    public getAllCenters(): Observable<string[]> {
        return this.http.get<string[]>(this.profileUrl + '/centers', { headers: this.getHeaders() });
    }

    public getAllProfileNames(): Observable<string[]> {
        return this.http.get<string[]>(this.profileUrl + '/names', { headers: this.getHeaders() });
    }
}
